import { SubscriptionsState, SubscriptionKey } from "../type";

export function removeUserFromSub(
  state: SubscriptionsState,
  key: SubscriptionKey,
  userId: string,
) {
  state[key] = state[key].filter((u) => u.userId !== userId);
}
